import React from "react";
import Coppe from "../../../../../assets/parceiros/coppe.svg";
import Amazon from "../../../../../assets/parceiros/amazon.svg";
import Lncc from "../../../../../assets/parceiros/lncc.png";
import Qualicorp from "../../../../../assets/parceiros/qualicorp.png";
import Surgbook from "../../../../../assets/parceiros/surgbook.png";
import Sebrae from "../../../../../assets/parceiros/sebrae.svg";

import Gama from "../../../../../assets/parceiros/gama.svg";
import CAMPERJ from "../../../../../assets/parceiros/camperj.svg";
import CAMARJ from "../../../../../assets/parceiros/camarj.svg";

import Qsaude from "../../../../../assets/parceiros/qsaude.svg";
import Viva from "../../../../../assets/parceiros/viva.svg";
import Fbstart from "../../../../../assets/parceiros/fbstart.png";

import Lemobs from "../../../../../assets/parceiros/lemobs.svg";
import LabFuturo from "../../../../../assets/parceiros/labfuturo.png";
import InovativaBrasil from "../../../../../assets/parceiros/inovativabrasil.svg";
import Sigelu from "../../../../../assets/parceiros/sigelu.svg";
import CRC from "../../../../../assets/parceiros/crc.png";
import { Carousel } from "../../../../carousel/Carousel";
import { CarouselItemMultiple } from "../../../../carousel/ItemMultiple";

export const HomeCarouselParceiros = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <h1 className="col text-center text-primary font-weight-bold py-5">
          Parceiros e Clientes
        </h1>
      </div>
      <div className="row">
        <div className="col d-sm-none">
          <Carousel settings={{ autoplay: false, autoplaySpeed: 3000 }}>
            <CarouselItemMultiple
              parceiros={[
                [Qualicorp, Sebrae],
                [Coppe, Lncc],
              ]}
            />
            <CarouselItemMultiple
              parceiros={[
                [Gama, CAMPERJ],
                [CAMARJ, Qsaude],
              ]}
            />
            <CarouselItemMultiple
              parceiros={[
                [Viva, Fbstart],
                [Lemobs, LabFuturo],
              ]}
            />
            <CarouselItemMultiple
              parceiros={[[InovativaBrasil, Sigelu], [Amazon, Surgbook], [CRC]]}
            />
          </Carousel>
        </div>
        <div className="col d-none d-sm-block">
          <Carousel
            settings={{ autoplay: false, dots: false, autoplaySpeed: 3000 }}
          >
            <CarouselItemMultiple
              parceiros={[
                [Qualicorp, Sebrae, Coppe],
                [Lncc, Surgbook, Amazon],
                [Gama, CAMPERJ, CAMARJ],
                [Viva, Fbstart, Qsaude],
                [Lemobs, LabFuturo, InovativaBrasil],
                [CRC, Sigelu],
              ]}
            />
          </Carousel>
        </div>
      </div>
    </div>
  );
};
